import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'button', 'content' ]

  connect() {
    if (this.data.get('expand') === 'open') {
      this.open()
    } else {
      this.close()
    }
  }

  toggle() {
    if (this.data.get('expand') === 'open') {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.buttonTarget.querySelector('span').innerText = 'Close'
    this.buttonTarget.querySelector('i').innerText = 'expand_less'
    this.contentTarget.classList.remove('d-none')
    this.data.set('expand', 'open')
  }

  close() {
    this.buttonTarget.querySelector('span').innerText = 'Open'
    this.buttonTarget.querySelector('i').innerText = 'expand_more'
    this.contentTarget.classList.add('d-none')
    this.data.set('expand', 'close')
  }

  async replace(event) {
    console.log('=== SECTION REPLACE ===')
    
    // CRITICAL: Prevent Turbo from processing the response
    // This must be in turbo:before-fetch-response, not turbo:submit-end
    if (event.preventDefault) {
      event.preventDefault()
      console.log('✓ Prevented Turbo navigation')
    }
    
    let response

    // Turbo format: event.detail.fetchResponse.responseText is a Promise
    if (event.detail?.fetchResponse) {
      try {
        response = await event.detail.fetchResponse.responseText
        console.log('✓ Response received, length:', response?.length)
      } catch (e) {
        console.error('Error extracting response:', e)
      }
    }

    if (response && typeof response === 'string' && response.trim().length > 0) {
      this.contentTarget.innerHTML = response
      this.element.dispatchEvent(new CustomEvent('sectioncomplete', { bubbles: true }))
      console.log('✓ Section replaced successfully')
    } else {
      console.error('⚠️ Section replace failed')
    }
  }
}
